import React from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';

import './ChildAside.scss';

const ChildAside = ({ isChild }) => {
  return ReactDOM.createPortal(
    <aside id="child-sidebar" className={classnames({ coppa: isChild })}></aside>,
    document.body
  );
};

export default ChildAside;
